import React, { useRef, useCallback, useState, useEffect } from 'react';
import * as S from './styles';
import { MainContainer } from 'components/shared';

export const Billing: React.FC = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const handleClick = useCallback(() => {
    if (ref.current) {
      if (window.document.fullscreenElement) {
        if (window.document.exitFullscreen) {
          window.document.exitFullscreen();
        }
      } else {
        ref.current.requestFullscreen();
      }
    }
  }, []);

  const handleKeyDown = useCallback(() => {
    setIsFullscreen((v) => !v);
  }, []);

  useEffect(() => {
    if (window.document) {
      window.document.addEventListener('fullscreenchange', handleKeyDown);
    }

    return () => {
      window.document.removeEventListener('fullscreenchange', handleKeyDown);
    };
  }, [handleKeyDown]);

  return (
    <MainContainer>
      <S.Container ref={ref}>
        <S.Button onClick={handleClick}>
          {isFullscreen ? <S.IconExitFullscreen /> : <S.IconFullscreen />}
        </S.Button>

        <S.Iframe
          width="100%"
          height="100%"
          src={
            'https://analytics.zoho.com/open-view/1432280000272786927/a4c3783f016a8eef731838f6bf4b9068de2f10db28185bb9d0e264246f1490ce'
          }
        />
      </S.Container>
    </MainContainer>
  );
};
